import {Scale, ArrowRight} from 'lucide-react'
import { useCalculator } from "@/context/CalculatorContext"

export default function YieldScalingCard() {
  const { yieldOriginal, yieldTarget, setYieldOriginal, setYieldTarget, scaleByYield } =
    useCalculator()

  const factor =
    yieldOriginal > 0 ? (yieldTarget / yieldOriginal).toFixed(4) : "—"

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 card-hover">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-9 h-9 bg-indigo-50 rounded-lg flex items-center justify-center flex-shrink-0">
          <Scale size={17} className="text-indigo-600" strokeWidth={2.2} />
        </div>
        <div>
          <h2 className="text-base font-semibold text-gray-900 leading-tight">Scale Recipe Yield</h2>
          <p className="text-xs text-gray-500 mt-0.5">
            Multiply all ingredient weights by the conversion factor
          </p>
        </div>
      </div>

      <div className="grid grid-cols-[1fr_auto_1fr] gap-2 items-end mb-4">
        <div>
          <label className="block text-xs font-semibold text-gray-600 mb-1.5 uppercase tracking-wider">
            Original Yield
          </label>
          <div className="relative">
            <input
              type="number"
              min="0.01"
              step="1"
              value={yieldOriginal}
              onChange={(e) => {
                const v = parseFloat(e.target.value)
                if (v > 0) setYieldOriginal(v)
              }}
              className="w-full tabular-nums text-right pr-12 pl-3 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-shadow"
            />
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-400">units</span>
          </div>
        </div>
        <div className="pb-2.5">
          <ArrowRight size={16} className="text-gray-300" />
        </div>
        <div>
          <label className="block text-xs font-semibold text-gray-600 mb-1.5 uppercase tracking-wider">
            Target Yield
          </label>
          <div className="relative">
            <input
              type="number"
              min="0.01"
              step="1"
              value={yieldTarget}
              onChange={(e) => {
                const v = parseFloat(e.target.value)
                if (v > 0) setYieldTarget(v)
              }}
              className="w-full tabular-nums text-right pr-12 pl-3 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-shadow"
            />
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-400">units</span>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between bg-gray-50 rounded-lg px-4 py-2.5 mb-4 border border-gray-100">
        <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Conversion Factor</span>
        <span className="text-sm font-bold text-indigo-700 tabular-nums">{factor}×</span>
      </div>

      <button
        onClick={scaleByYield}
        disabled={yieldOriginal <= 0}
        className="w-full bg-indigo-600 text-white text-sm font-semibold py-2.5 px-4 rounded-lg hover:bg-indigo-700 active:scale-[0.98] transition-all disabled:opacity-40 disabled:cursor-not-allowed shadow-sm hover:shadow"
      >
        Scale Formula
      </button>
    </div>
  )
}
